<template>
  <div>
    <div class="page-container">
      <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item>blockInfo</el-breadcrumb-item>
    </el-breadcrumb> -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <span class="page-title">财务报表</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>地址余额</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card class="page-content" shadow="never">
        <div class="page-actions">
          <!-- <el-input v-model="val1" placeholder="请输入用户Id" clearable>
          
          </el-input> -->
          <el-select v-model="coin" placeholder="请筛选币种" clearable>
            <el-option
              v-for="item in allCoins"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select v-model="val1" placeholder="请筛选链" clearable>
            <el-option
              v-for="item in chainsData"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <!-- <el-select v-model="type" placeholder="请筛选订单类型" clearable>
            <el-option
              v-for="item in allCoins"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select> -->
          <!-- <el-date-picker
        
          v-model="value2"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker> -->
          <el-button type="primary" @click="handleSearch" >搜索</el-button>
          <a  @click="getExcel" target="_blank" >导出Excel</a>
        </div>
        <user-list @refresh="refreshList" ></user-list>
      </el-card>
    </div>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState } from "vuex";
import UserList from "./components/list";
export default {
  components: {
    UserList,
  },
  data() {
    return {
        val1:'',
       coin:'',
       type:'',
        value2:'',
        page:1,size:25,
       
    };
  },
  computed: {
    ...mapState('addressBlance',['allCoins','chainsData']),
  },
  methods: {
    ...mapActions('addressBlance',['getOrderList','getChains','exportExcel','getFbsPairs','getAllCoins']),
    refreshList(data={}){
        this.page=data.page
        this.size=data.size
        this.getOrderList({
          coinType:this.coin,
        chain:this.val1,
        page:this.page,size:this.size,
        
        ...data
    })
    },
    handleSearch(){
        this.getOrderList({
          coinType:this.coin,
        chain:this.val1,
        page:1,size:this.size,
    })
    },
    getExcel(){
        this.exportExcel({
          address:'',
            coinType:this.coin,
            chain:this.val1
        }).then(res=>{
        console.log('res',res);
            const link=document.createElement('a') 
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
            link.style.display = 'none'
            // 设置连接
            link.href = URL.createObjectURL(blob)  //将文件流转化为blob地址
            console.log('link-href',link.href);
            link.download = '地址余额统计报表'
            document.body.appendChild(link)
            // 模拟点击事件
            link.click()  //设置点击事件
         
       

      }).catch(error=>{
        this.$message.error(error)
      });
    }
  },
  created() {
    this.getOrderList({
        coinType:this.coin,
        page:this.page,size:this.size,
        chain:this.val1,
        
    })
    this.getChains()
    this.getAllCoins()
  },
};
</script>

<style lang="less" scoped>
.page-actions {
  margin-bottom: 10px;
}
</style>
